import React, { useEffect, useState, useRef } from 'react';
import styled from 'styled-components';
import Slider from 'react-slick';
import DoneIcon from '@material-ui/icons/Done';
import CloseIcon from '@material-ui/icons/Close';

import MuiWrapper from 'components/common/input/MuiWrapper';
import MuiButton from 'components/common/button/MuiButton';
import CustomSpan from 'components/common/text/CustomSpan';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { icon_user_circle, icon_request_post } from 'components/base/images';
import { ContactsOutlined } from '@material-ui/icons';
import moment from 'moment';
import DateConverter from 'components/common/convert/DateConverter';
import ImgCrop from 'components/common/images/ImgCrop';
import { partnerTypeList } from 'lib/mapper';
import T from 'components/common/text/T';

const PartnerRequestSlick = ({
  receiveRequest,
  onClickPartnerRequest = (partner, answer) => {},
}) => {
  const [nav1, setNav1] = useState([]);
  const [nav2, setNav2] = useState([]);
  const slickRef = useRef();
  const contentsLength = receiveRequest?.length;
  // const contentsLength = 2;
  // const slidesToShowCount =
  //   contentsLength > 4 ? 5 : contentsLength < 5 && contentsLength > 2 ? 3 : 1;

  const slidesToShowCount = contentsLength > 4 ? 3 : 1;

  const centerPadding = contentsLength > 4 ? '83px' : contentsLength > 2 ? '142px' : '0px';

  let slider1 = [];
  let slider2 = [];

  useEffect(() => {
    setNav1(slider1);
    setNav2(slider2);
  }, []);

  function SampleNextArrow(props) {
    const { className, style, onClick } = props;

    return (
      <div className={className} onClick={onClick}>
        <MuiButton disableElevation className="arrow_box_wrapper">
          <CustomSpan fontSize={13} fontWeight={200} fontColor="#B5B7C1">
            NEXT
          </CustomSpan>
          <div className="arrow_icon_box next">
            <div className="arrow_icon next"></div>
          </div>
        </MuiButton>
      </div>
    );
  }

  function SamplePrevArrow(props) {
    const { className, style, onClick } = props;
    return (
      <div className={className} onClick={onClick}>
        <MuiButton disableElevation className="arrow_box_wrapper">
          <div className="arrow_icon_box prev">
            <div className="arrow_icon prev"></div>
          </div>
          <CustomSpan fontSize={13} fontWeight={200} fontColor="#B5B7C1">
            BACK
          </CustomSpan>
        </MuiButton>
      </div>
    );
  }

  const settings = {
    asNavFor: nav1,
    ref: slider => (slider2 = slider),
    centerMode: true,
    infinite: true,
    dots: false,
    // centerPadding: '142px',
    // centerPadding: '83px',
    centerPadding: centerPadding,
    // centerPadding: '142px',
    slidesToShow: slidesToShowCount,
    // slidesToShow: 3,
    speed: 200,
    arrows: false,
    slidesToScroll: 1,
    focusOnSelect: true,
    swipeToSlide: false,
    swipe: false,
  };

  const settings2 = {
    asNavFor: nav2,
    ref: slider => (slider1 = slider),
    centerMode: true,
    infinite: true,
    // fade: true,
    dots: false,
    centerPadding: '0px',
    // centerPadding: '60px',
    slidesToShow: 1,
    speed: 0,
    swipe: false,
    swipeToSlide: false,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
  };

  return (
    <StyledPartnerRequestSlick data-component-name="PartnerRequestSlick">
      <div className="partnerRequestSlick__container">
        <div className="partnerRequestSlick__slider_wrapper" ref={slickRef}>
          <div className="partnerRequestSlick__slider_image">
            <StyledCustomSlick {...settings} slidesToShowCount={slidesToShowCount}>
              {receiveRequest.map((item, index) => (
                <div className="slide_item_box" key={index}>
                  <div className="slide_item_wrapper">
                    <div className="slide_item">
                      {!!item.profileImg ? (
                        <ImgCrop width={85} isCircle isBorder isBackColor src={item.profileImg} />
                      ) : (
                        <img src={icon_user_circle} className="empty_image" />
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </StyledCustomSlick>
          </div>

          <StyledCustomSlick2 {...settings2}>
            {receiveRequest.map((item, index) => {
              return (
                <div className="slide_item_info_box_wrapper" key={index}>
                  <div className="slide_item_info_box" key={index}>
                    <div className="slide_item_info_row name">
                      <CustomSpan fontSize={23} fontWeight={500} fontColor="#25256f">
                        <T>{partnerTypeList.find(i => i.id === item.userTypeIdx)?.text}</T>
                      </CustomSpan>
                      <div className="name_section"></div>
                      <CustomSpan fontSize={23} fontWeight={500} fontColor="#303030">
                        {item.name}
                      </CustomSpan>
                    </div>

                    {/* <div>
                      <CustomSpan fontSize={11} fontWeight={400} fontColor="#B5B7C1">
                        <DateConverter timestamp={item.enrollDate} format="YY.MM.DD hh:mm" />
                      </CustomSpan>
                    </div> */}

                    <CustomSpan fontSize={16} fontWeight={400} fontColor="#303030">
                      has invited you to connect
                    </CustomSpan>

                    <div className="slide_item_count">
                      <img src={icon_request_post} />
                      <CustomSpan
                        fontSize={11}
                        fontWeight={400}
                        marginLeft={10}
                        fontColor="#33B5E4"
                      >
                        {index + 1}
                        {'/'}
                        {contentsLength}
                      </CustomSpan>
                      <CustomSpan
                        fontSize={11}
                        fontWeight={400}
                        fontColor="#B5B7C1"
                        marginLeft={20}
                      >
                        <DateConverter timestamp={item.enrollDate} format="YY.MM.DD hh:mm" />
                      </CustomSpan>
                    </div>
                    <div className="slide_item_info_botton_box">
                      <MuiWrapper className="slide_item_info_botton_wrapper reject">
                        <MuiButton
                          disableElevation
                          className="slide_item_info_botton cancel"
                          variant="contained"
                          color="default"
                          onClick={() => {
                            onClickPartnerRequest(item, 0);
                          }}
                        >
                          <CloseIcon />
                        </MuiButton>
                      </MuiWrapper>
                      <MuiWrapper className="slide_item_info_botton_wrapper accept">
                        <MuiButton
                          disableElevation
                          className="slide_item_info_botton done"
                          variant="contained"
                          color="primary"
                          onClick={() => {
                            onClickPartnerRequest(item, 1);
                          }}
                        >
                          <DoneIcon />
                        </MuiButton>
                      </MuiWrapper>
                    </div>
                  </div>
                </div>
              );
            })}
          </StyledCustomSlick2>
        </div>
      </div>
    </StyledPartnerRequestSlick>
  );
};
const StyledPartnerRequestSlick = styled.section`
  .partnerRequestSlick__container {
    margin: 0 auto;
    width: 410px;
  }
`;
const StyledCustomSlick = styled(Slider)`
  .partnerRequestSlick__slider_image {
    margin: 0 auto;
    padding: 30px 40px 30px 40px;
    width: 410px;
    height: 140px;
  }
  /* .slick-slide {
    margin-top: -21px;
  }
  .slide_item_box {
    position: relative;
    z-index: 5;
    line-height: 140px;
    .slide_item_wrapper {
      .slide_item {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        .empty_image {
          width: 85px;
          height: 85px;
        }
      }
    }
  } */

  .slick-slide {
    /* margin-top: -21px; */
    margin-top: ${({ slidesToShowCount }) =>
      slidesToShowCount === 1 ? '-12px !important' : '-21px'};
    .slide_item_box {
      position: relative;
      z-index: 5;
      line-height: 140px;
      transform: ${({ slidesToShowCount }) =>
        slidesToShowCount === 1 ? 'scale(1.2)' : 'scale(1)'};
      -ms-transform: ${({ slidesToShowCount }) =>
        slidesToShowCount === 1 ? 'scale(1.2)' : 'scale(1)'};

      .slide_item_wrapper {
        .slide_item {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 100%;

          .empty_image {
            width: 85px;
            height: 85px;
            border-radius: 50%;
            box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
          }
        }
      }
    }
  }

  .slick-active {
    &:not(.slick-center) {
      margin-top: -12px !important;
      .slide_item_box {
        position: relative;
        z-index: 10;
        -ms-transform: scale(1.2);
        transform: scale(1.2);
      }
    }
    &.slick-center {
      margin-top: 0 !important;
      .slide_item_box {
        position: relative;
        z-index: 15;
        -ms-transform: scale(1.5);
        transform: scale(1.5);
      }
    }
  }

  .slick-active .slide_item_box {
    transition: all 0.3s ease;
  }

  .slick-list {
    height: 140px;
    margin-bottom: 30px;
    padding-top: 22px !important;
    /* padding-top: 30px !important; */
  }
`;

const StyledCustomSlick2 = styled(Slider)`
  .slide_item_info_botton_box {
    margin-top: 32px;
    .slide_item_info_botton_wrapper {
      height: 70px;
      svg {
        width: 40px;
        height: 40px;
      }
    }

    .slide_item_info_botton {
      width: 65px;
      height: 65px;
      border-radius: 50%;
      color: #ffffff;
      &.cancel {
        margin-right: 30px;
      }
    }
  }
  .slide_item_info_box {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    row-gap: 6px;
    .slide_item_count {
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .slide_item_info_row {
      &.name {
        display: flex;
        align-items: center;
        height: 25px;
        .name_section {
          width: 1px;
          height: 18px;
          background-color: #444;
          margin: 0 14px;
        }
      }
    }
  }

  .slick-arrow {
    &.slick-next,
    &.slick-prev {
      width: 127px;
      height: 40px;
      border: 1px solid #b5b7c1;
      border-radius: 5px;
      top: 140px !important;
      transform: translate(0, 0);
      z-index: 50;
    }
    &.slick-next {
      right: -28px !important;
    }
    &.slick-prev {
      left: -28px !important;
    }
    &.slick-prev:before,
    &.slick-next:before {
      display: none;
    }

    .arrow_box_wrapper {
      width: 127px;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .arrow_icon_box {
        width: 8px;
        height: 8px;
        border-top: 2px solid #b5b7c1;
        border-left: 2px solid #b5b7c1;
        &.prev {
          transform: rotate(-45deg);
        }
        &.next {
          transform: rotate(135deg);
        }
        &:after {
          content: '';
          display: block;
          width: 2px;
          height: 30px;
          background-color: #b5b7c1;
          transform: rotate(-45deg) translate(10px, 3px);
          left: 0;
          top: 0;
        }
      }
    }
  }
`;
export default React.memo(PartnerRequestSlick);
